<app-header></app-header>

<!--====== PAGE TITLE PART START ======-->
<div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData; let i=index" [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <span class="assurance">
                                   {{slide.type}}
                                </span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" [src]="slide.imgIcon" alt="">
                            </div>
                            <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title" *ngIf="title!=''">{{title}}</span>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="nextStep()">Obtenir un devis</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="case-studies-area">
  <div class="container">
    
    <div class="latest-services-area">
      <div class="container">
        <div class="formulaire" *ngIf="currentStep > 0">
          <div class="form-wizard-container">
            
            <!-- Étape d'accueil -->
            <div class="welcome-step" *ngIf="currentStep === 0">
              <div class="welcome-content">
                <h1>Bonjour ! Je suis votre conseiller</h1>
                <h2>Je suis là pour vous accompagner</h2>
                <p class="welcome-description">
                  Obtenez votre devis d'assurance responsabilité civile entreprise en quelques minutes.
                  Je vais vous guider étape par étape pour protéger au mieux votre entreprise.
                </p>
                <button class="cta-button" (click)="nextStep()">
                  Commencer !
                </button>
              </div>
            </div>

            <!-- Étape 1: Informations entreprise -->
            <div class="step-container" *ngIf="currentStep === 1">
              <div class="step-header">
                <h2>Informations sur votre entreprise</h2>
                <p class="step-subtitle">Parlez-nous de votre société</p>
                <div class="step-progress">Étape 1 sur {{totalSteps - 1}}</div>
              </div>

              <form [formGroup]="entreprise1Form">
                <div class="form-grid formulaire">
                  <div class="input-box mt-30">
                    <input type="text" formControlName="raisonSocial" placeholder="Nom ou Raison Sociale *">
                    <!-- <img class="img-form" title="Raison sociale"
                      src="assets/images/nom.svg" alt=""> -->
                    <i class="barre"></i>
                  </div>
                  
                  <div class="input-box mt-30">
                    <input type="text" formControlName="adresse" placeholder="Adresse de l'entreprise *">
                    <!-- <img class="img-form" title="Adresse"
                      src="assets/images/icon-adresse.svg" alt=""> -->
                    <i class="barre"></i>
                  </div>
                </div>

                <div class="form-grid formulaire">
                  <div class="input-box">
                    <ng-select formControlName="formeJuridique" 
                              clearAllText="Effacer tout" 
                              notFoundText="Aucun élément trouvé"
                              [items]="listStatutJuridique" 
                              bindLabel="name" 
                              bindValue="id"
                              placeholder="Forme juridique *">
                    </ng-select>
                    <!-- <span class="input-icon">
                      <img src="assets/images/icon-fonction.svg" alt="">
                    </span> -->
                  </div>

                  <div class="input-box">
                    <input type="text" 
                           formControlName="dateExploitation"
                           bsDatepicker
                           [maxDate]="newDate"
                           [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', locale: 'fr'}"
                           placeholder="Date de mise en exploitation *">
                    <!-- <span class="input-icon">
                      <img src="assets/images/icon-date.svg" alt="">
                    </span> -->
                  </div>
                </div>

                <div class="formulaire">
                  <div class="input-area">
                    <div class="input-textarea">
                      <textarea formControlName="activiteEntreprise" 
                              placeholder="Activité de l'entreprise"
                              rows="3"></textarea>
                      <!-- <img class="img-form" title="Activité"
                        src="assets/images/icon-fonction.svg" alt=""> -->
                      <!-- <i class="barre"></i> -->
                    </div>
                  </div>
                </div>
              </form>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 2: Informations financières -->
            <div class="step-container" *ngIf="currentStep === 2">
              <div class="step-header">
                <h2>Informations financières</h2>
                <p class="step-subtitle">Détails sur l'activité de votre entreprise</p>
                <div class="step-progress">Étape 2 sur {{totalSteps - 1}}</div>
              </div>

              <form [formGroup]="entreprise1Form">
                <div class="form-grid formulaire">
                  <div class="input-box">
                    <input type="text" 
                           formControlName="chiffreAffairePreci" 
                           placeholder="Chiffre d'affaire prévisionnel *">
                    <!-- <img class="img-form" title="CA prévisionnel"
                      src="assets/images/icon-fonction.svg" alt=""> -->
                    <i class="barre"></i>
                  </div>

                  <div class="input-box">
                    <input type="number" 
                           formControlName="masseSalarialPreci" 
                           placeholder="Masse salariale prévisionnelle *">
                    <!-- <img class="img-form" title="Masse salariale"
                      src="assets/images/icon-fonction.svg" alt=""> -->
                    <i class="barre"></i>
                  </div>
                </div>

                <div class="form-grid formulaire">
                  <div class="input-box">
                    <input type="number" 
                           formControlName="nbrPersonnel" 
                           placeholder="Nombre de personnes employées *">
                    <!-- <img class="img-form" title="Nombre employés"
                      src="assets/images/nom.svg" alt=""> -->
                    <i class="barre"></i>
                  </div>
                </div>

                <div class="formulaire">
                  <!-- <div class="input-box">
                    <textarea formControlName="chiffreAffaire" 
                             placeholder="Chiffre d'affaire des cinq derniers exercices"
                             rows="3"></textarea>
                    <i class="barre"></i>
                  </div> -->
                  <div class="input-area">
                    <div class="input-textarea">
                      <textarea formControlName="chiffreAffaire" 
                              placeholder="Chiffre d'affaire des cinq derniers exercices"
                              rows="3"></textarea>
                    </div>
                  </div>
                </div>

                <div class="formulaire">
                  <!-- <div class="input-textarea">
                    <textarea formControlName="masseSalarial" 
                             placeholder="Masse salariale des cinq derniers exercices"
                             rows="3"></textarea>
                    <i class="barre"></i>
                  </div> -->
                   <div class="input-area">
                    <div class="input-textarea">
                      <textarea formControlName="masseSalarial" 
                              placeholder="Masse salariale des cinq derniers exercices"
                              rows="3"></textarea>
                    </div>
                  </div>
                </div>

                <div class="formulaire">
                  <!-- <div class="input-box">
                    <textarea formControlName="clientList" 
                             placeholder="Principaux clients"
                             rows="3"></textarea>
                    <img class="img-form" title="Clients"
                      src="assets/images/nom.svg" alt="">
                    <i class="barre"></i>
                  </div> -->
                  <div class="input-area">
                    <div class="input-textarea">
                      <textarea formControlName="clientList" 
                              placeholder="Principaux clients"
                              rows="3"></textarea>
                    </div>
                  </div>
                </div>
              </form>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 3: Questions complémentaires -->
            <div class="step-container" *ngIf="currentStep === 3">
              <div class="step-header">
                <h2>Questions complémentaires</h2>
                <p class="step-subtitle">Quelques précisions sur votre activité</p>
                <div class="step-progress">Étape 3 sur {{totalSteps - 1}}</div>
              </div>

              <form [formGroup]="entreprise2Form">
                <div class="question-section">
                  <h3>Effectuez-vous des travaux de chargement et déchargement avec les véhicules appartenant à des tiers ?</h3>
                  <div class="radio-group">
                    <label class="radio-option">
                      <input type="radio" formControlName="travaux" value="OUI">
                      <span class="radio-text">OUI</span>
                    </label>
                    <label class="radio-option">
                      <input type="radio" formControlName="travaux" value="NON">
                      <span class="radio-text">NON</span>
                    </label>
                  </div>

                  <div class="formulaire" *ngIf="entreprise2Form.get('travaux')?.value === 'OUI'">
                    <!-- <div class="input-box">
                      <textarea formControlName="descriptionAppareil" 
                               placeholder="Décrivez les appareils servant au transport ou au lavage"
                               rows="3"></textarea>
                      <img class="img-form" title="Description appareils"
                        src="assets/images/icon-fonction.svg" alt="">
                      <i class="barre"></i>
                    </div> -->
                     <div class="input-area">
                    <div class="input-textarea">
                      <textarea formControlName="descriptionAppareil" 
                              placeholder="Décrivez les appareils servant au transport ou au lavage"
                              rows="3"></textarea>
                    </div>
                  </div>
                  </div>
                </div>

                <div class="question-section">
                  <h3>L'entreprise est-elle locataire ou propriétaire des locaux qu'elle occupe ?</h3>
                  <div class="radio-group">
                    <label class="radio-option">
                      <input type="radio" formControlName="locataireOrProprietaire" value="LOCATAIRE">
                      <span class="radio-text">LOCATAIRE</span>
                    </label>
                    <label class="radio-option">
                      <input type="radio" formControlName="locataireOrProprietaire" value="PROPRIETAIRE">
                      <span class="radio-text">PROPRIÉTAIRE</span>
                    </label>
                  </div>
                </div>

                <div class="question-section">
                  <h3>L'entreprise entrepose-t-elle ou utilise-t-elle des matières dangereuses ?</h3>
                  <div class="radio-group">
                    <label class="radio-option">
                      <input type="radio" formControlName="entrepose" value="OUI">
                      <span class="radio-text">OUI</span>
                    </label>
                    <label class="radio-option">
                      <input type="radio" formControlName="entrepose" value="NON">
                      <span class="radio-text">NON</span>
                    </label>
                  </div>

                  <div class="formulaire" *ngIf="entreprise2Form.get('entrepose')?.value === 'OUI'">
                    <!-- <div class="input-box">
                      <textarea formControlName="matiere" 
                               placeholder="Décrivez les matières dangereuses"
                               rows="3"></textarea>
                      <img class="img-form" title="Matières dangereuses"
                        src="assets/images/icon-fonction.svg" alt="">
                      <i class="barre"></i>
                    </div> -->
                     <div class="input-area">
                        <div class="input-textarea">
                          <textarea formControlName="matiere" 
                                  placeholder="Décrivez les matières dangereuses"
                                  rows="3">
                          </textarea>
                        </div>
                     </div>
                  </div>
                </div>

                <div class="formulaire">
                  <!-- <div class="input-box">
                    <textarea formControlName="autreDeclaration" 
                             placeholder="Autres déclarations (optionnel)"
                             rows="3"></textarea>
                    <img class="img-form" title="Autres déclarations"
                      src="assets/images/icon-fonction.svg" alt="">
                    <i class="barre"></i>
                  </div> -->
                  <div class="input-area">
                        <div class="input-textarea">
                          <textarea formControlName="autreDeclaration" 
                                  placeholder="Autres déclarations (optionnel)"
                                  rows="3">
                          </textarea>
                        </div>
                  </div>
                </div>
              </form>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 4: Questionnaire médical -->
            <div class="step-container" *ngIf="currentStep === 4">
              <div class="step-header">
                <h2>Questionnaire RCE</h2>
                <p class="step-subtitle">Document obligatoire pour finaliser</p>
                <div class="step-progress">Étape 4 sur {{totalSteps - 1}}</div>
              </div>

              <!-- Téléchargement du questionnaire -->
              <div class="download-section" *ngIf="downloadFile">
                <div class="download-card">
                  <div class="download-icon">
                    <img [src]="downloadIcon" alt="Télécharger">
                  </div>
                  <div class="download-content">
                    <h3>Questionnaire RCE obligatoire</h3>
                    <p>Téléchargez et remplissez ce questionnaire avant de continuer</p>
                    <button type="button" class="download-button" (click)="downloadModel()">
                      <i class="fa fa-download"></i>
                      Télécharger le questionnaire
                    </button>
                  </div>
                </div>
              </div>

              <!-- Upload du questionnaire -->
              <div class="upload-section">
                <div class="upload-area" (click)="fileInput.click()" 
                     [class.has-file]="pieceJointeForm.get('file')?.value">
                  <input #fileInput type="file" hidden 
                         (change)="selectOnFile($event, 'PIECEJOINTE', 'PIECEJOINTE')"
                         accept=".pdf,.doc,.docx,.docm,.xls,.xlsx,.png,.jpg,.jpeg">
                  
                  <div class="upload-content" *ngIf="!pieceJointeForm.get('file')?.value">
                    <i class="fa fa-cloud-upload upload-icon"></i>
                    <h3>Charger le questionnaire</h3>
                    <p>Cliquez ici ou glissez-déposez votre fichier</p>
                    <small class="text-muted">Formats acceptés: PDF, DOC, DOCX, XLS, XLSX, PNG, JPG</small>
                  </div>
                  
                  <div class="file-success" *ngIf="pieceJointeForm.get('file')?.value">
                    <i class="fa fa-check-circle success-icon"></i>
                    <div class="file-info">
                      <p><strong>Questionnaire chargé avec succès</strong></p>
                      <small class="file-name" *ngIf="nomFile">{{ nomFile }}</small>
                    </div>
                    <div class="file-icon" *ngIf="noImage !== 'assets/images/upload.png'">
                      <img [src]="noImage" alt="File type icon" class="file-type-icon">
                    </div>
                  </div>
                </div>
                
                <div class="loader-container" *ngIf="loader">
                  <i class="fa fa-spinner fa-pulse"></i>
                  <p>Chargement du fichier...</p>
                </div>
                
                <div class="error-message" *ngIf="pieceJointeForm.get('file')?.invalid && pieceJointeForm.get('file')?.touched">
                  <small class="text-danger">
                    <i class="fa fa-exclamation-triangle"></i>
                    Le questionnaire RCE est obligatoire pour continuer
                  </small>
                </div>
              </div>

              <div class="privacy-notice">
                <i class="fa fa-info-circle"></i>
                Le questionnaire RCE est obligatoire pour l'assurance responsabilité civile entreprise. 
                Vos données sont traitées de manière confidentielle selon notre politique de confidentialité.
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">
                  <i class="fa fa-arrow-left"></i>
                  Retour
                </button>
                <button class="btn-continue" 
                        [disabled]="!pieceJointeForm.get('file')?.value || loader"
                        (click)="nextStep()">
                  <i class="fa fa-calculator"></i>
                  Voir le récapitulatif
                </button>
              </div>
            </div>

            <!-- Étape 5: Récapitulatif -->
            <div class="step-container" *ngIf="currentStep === 5">
              <div class="step-header">
                <h2>Récapitulatif de votre demande RCE</h2>
                <p class="step-subtitle">Vérifiez vos informations avant de finaliser</p>
              </div>

              <div class="recap-form-container">
                <div class="mesImage">
                  <div class="imgLogo">
                    <img src="assets/images/logo.png" alt="Logo Inclusive Guarantee">
                  </div>
                </div>
                
                <div class="info-devis">
                  <div class="proposition">
                    <div class="pro-title">Demande d'assurance RCE</div>
                    <div class="sub-title">{{numeroSous}}</div>
                  </div>
                  
                  <!-- Informations entreprise -->
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations entreprise</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Numéro</div>
                            <div class="col-7 value">{{numeroSous}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Raison sociale</div>
                            <div class="col-7 value">{{entreprise1Form?.get('raisonSocial')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Adresse</div>
                            <div class="col-7 value">{{entreprise1Form?.get('adresse')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Forme juridique</div>
                            <div class="col-7 value">{{getFormeJuridiqueLabel(entreprise1Form?.get('formeJuridique')?.value)}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Date exploitation</div>
                            <div class="col-7 value">{{entreprise1Form?.get('dateExploitation')?.value | date:'dd/MM/yyyy'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Informations financières -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations financières</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">CA prévisionnel</div>
                            <div class="col-7 value">{{entreprise1Form?.get('chiffreAffairePreci')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Masse salariale prév.</div>
                            <div class="col-7 value">{{entreprise1Form?.get('masseSalarialPreci')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Nombre employés</div>
                            <div class="col-7 value">{{entreprise1Form?.get('nbrPersonnel')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Activité</div>
                            <div class="col-7 value">{{entreprise1Form?.get('activiteEntreprise')?.value}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Questions complémentaires -->
                  <div class="row">
                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
                      <div class="title-div">
                        <span>Questions complémentaires</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                            <div class="row">
                              <div class="col-12 d-flex">
                                <div class="col-5 name">Travaux chargement</div>
                                <div class="col-7 value">{{entreprise2Form?.get('travaux')?.value}}</div>
                              </div>
                              <div class="col-12 d-flex">
                                <div class="col-5 name">Statut locaux</div>
                                <div class="col-7 value">{{entreprise2Form?.get('locataireOrProprietaire')?.value}}</div>
                              </div>
                              <div class="col-12 d-flex">
                                <div class="col-5 name">Matières dangereuses</div>
                                <div class="col-7 value">{{entreprise2Form?.get('entrepose')?.value}}</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                            <div class="row">
                              <div class="col-12 d-flex">
                                <div class="col-5 name">Date de demande</div>
                                <div class="col-7 value">{{newDate | date:'dd/MM/yyyy'}}</div>
                              </div>
                              <div class="col-12 d-flex">
                                <div class="col-5 name">Statut</div>
                                <div class="col-7 value">En attente de validation</div>
                              </div>
                              <div class="col-12 d-flex">
                                <div class="col-5 name">Type risque</div>
                                <div class="col-7 value">Responsabilité Civile Entreprise</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Section document joint -->
                  <div class="row">
                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
                      <div class="title-div">
                        <span>Documents joints</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Questionnaire RCE</div>
                            <div class="col-7 value">
                              <span *ngIf="pieceJointeForm.get('file')?.value" class="text-success">
                                <i class="fa fa-check-circle"></i> Document fourni
                              </span>
                              <span *ngIf="!pieceJointeForm.get('file')?.value" class="text-warning">
                                <i class="fa fa-exclamation-triangle"></i> En attente
                              </span>
                            </div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="nomFile">
                            <div class="col-5 name">Nom du fichier</div>
                            <div class="col-7 value">{{nomFile}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="description-ass">
                    Cette demande d'assurance RCE sera traitée par nos équipes dans les plus brefs délais. 
                    Vous recevrez une confirmation par email avec les détails de votre couverture.
                  </div>
                  
                  <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Demande d'assurance RCE
                    </div>
                    <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Date émission : {{newDate | date:'dd/MM/yyyy'}} - E-MAIL : contact&#64;inclusiveguarantee.com
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">
                  <i class="fa fa-arrow-left"></i>
                  Retour
                </button>
                <button type="button" class="btn-continue final-btn" [swal]="confirmSubscription" [disabled]="sendingRequest">
                  <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequest"></i>
                  <span *ngIf="!sendingRequest">Finaliser la souscription</span>
                  <span *ngIf="sendingRequest">Traitement en cours...</span>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>

<swal #confirmSubscription title="Confirmation" text="Voulez-vous vraiment procéder à la souscription RCE ?" icon="question" [reverseButtons]="true" [showCancelButton]="true" [focusCancel]="false" [confirmButtonText]="'OUI, BIEN SÛR'" [cancelButtonText]="'NON, ANNULER'"
    (confirm)="saveData()">
</swal>